class ImageWithPlaceholder extends HTMLElement {
  constructor() {
    super();
    this.imageEl = this.querySelector('img');
    if (!this.imageEl) return;

    this.imageLoadedHandler = this.imageLoadedHandler.bind(this);
    this.imageErrorHandler = this.imageErrorHandler.bind(this);

    if (this.imageEl.complete) {
      this.loaded = this.imageEl.naturalWidth > 0;
      return;
    }

    this.imageEl.addEventListener('load', this.imageLoadedHandler, { once: true });
    this.imageEl.addEventListener('error', this.imageErrorHandler, { once: true });
  }

  get loaded() {
    return this._loaded;
  }

  set loaded(value) {
    this._loaded = value;
    this.imageEl.classList.toggle('is-complete', value);
  }

  imageLoadedHandler() {
    this.loaded = true;
    this.cleanup();
  }

  imageErrorHandler() {
    this.loaded = false;
    this.cleanup();
  }

  cleanup() {
    this.imageEl.removeEventListener('load', this.imageLoadedHandler);
    this.imageEl.removeEventListener('error', this.imageErrorHandler);
  }
}

if (!customElements.get('image-with-placeholder')) {
  customElements.define('image-with-placeholder', ImageWithPlaceholder);
}
